import { render, staticRenderFns } from "./MakePriceEditDialog.vue?vue&type=template&id=5e3dd927&scoped=true&"
import script from "./MakePriceEditDialog.vue?vue&type=script&lang=js&"
export * from "./MakePriceEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./MakePriceEditDialog.vue?vue&type=style&index=0&id=5e3dd927&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3dd927",
  null
  
)

export default component.exports